





















import { Component, Vue, Prop } from 'vue-property-decorator'
import schemaNavigationDrawer from '../../data/schema-navigation-drawer'
import schemaNavigationBottom from '../../data/schema-navigation-bottom'
import device from '../../../utils/services/current-device'
import { networks } from '../../data/base-networks'

@Component({
    components: {
        toolBar: () => import('../../components/core/Toolbar.vue'),
        navigationDrawer: () => import('../../components/core/NavigationDrawer.vue'),
        navigationBottom: () => import('../../components/core/NavigationBottom.vue')
    }
})
export default class Default extends Vue {

    showNavigationbar: boolean = false

    mounted() {
        this.$http.put(`${ process.env.VUE_APP_DOT_NET_API_BASE_URL }${ process.env.VUE_APP_DOT_NET_API_REFRESH }`)
    }

    get isDesktop() {
        return device.desktop()
    }

    get navigationComponent() {
        return this.isDesktop ? 'navigationDrawer' : 'navigationBottom'
    }

    get schemaNavigationDrawer() {
        return schemaNavigationDrawer
    }

    get schemaNavigationBottom() {
        return schemaNavigationBottom
    }

    get toolbarTitle() {
        // bit of futzing to grab the title from the meta field - have to check the matched array
        // to find the value we want
        if(this.$route.matched && this.$route.matched.length > 0) {
            // start at the end
            for(let i = this.$route.matched.length - 1; i >= 0; i--) {
                let m = this.$route.matched[i]
                if(m.meta && m.meta.title) {
                    return m.meta.title
                }
            }
        }
        // can't match - just set it to something
        return 'ReticManager'
    }
}

